import script from "./MergeContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MergeContactModal.vue?vue&type=script&setup=true&lang=js"

import "./MergeContactModal.vue?vue&type=style&index=0&id=44da5aef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44da5aef"]])

export default __exports__